import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "reactstrap";

import PointsBoost from "~/services/pointsBoosters";
import Timer from "./Timer";


const PointsBooster = ()=> {

  const [booster           , setBooster]           = useState(null);
  const [userActiveBooster , setuserActiveBooster] = useState(null);
  const [refresh           , setRefresh]           = useState(false);
  const [loading           , setLoading]           = useState(false);

  useEffect(()=> {
    (async ()=> {
      setBooster(await PointsBoost.getBoost());
      setuserActiveBooster(await PointsBoost.getActiveBoost())
    })();
  }, [refresh]);

  const startEvent = async ()=> {
    setLoading(true);
    PointsBoost.activateBooster().then(()=> {
      setLoading(false);
      setRefresh(true);
    })
  };

  return (
    <Fragment>
     { booster &&
      (<div className="activity-card">
        <h6 className="title"> {booster.title} </h6>
        <div>
          <small>You will receive {booster.percentage}% more points from offers and surveys!</small>
        </div>
        <span> Expire in </span> <div className="badge"> <Timer expirationDate={booster.endDate}></Timer> </div>
        <div>
          <button className="go-to" onClick={startEvent}>  { loading ? <span> <Spinner size="sm" /> Loading... </span> : <span>Claim bonus</span> } </button>
        </div>
      </div>)}

      { userActiveBooster &&
      (<div className="activity-card">
        <h6 className="title"> You have an active points booster from {userActiveBooster.source === 1 ? 'Booster Events' : "Check-In Rewards"}</h6>
        <div>
          <small>You will receive {userActiveBooster.percentage}% more points from offers and surveys!</small>
        </div>
        <span> Expire in </span> <div className="badge"> <Timer expirationDate={userActiveBooster.endDate} /> </div>
        <div>
          <button className="go-to" disabled> Points colected: {userActiveBooster.totalPointsGranted} </button>
        </div>
      </div>)}
    </Fragment>
  );
}

export default PointsBooster;
